<template>
    <app-layout>

        <bax-header-banner :user="this.$store.state.auth.user" :orderStep="2" :order="orderInfo" />

        <main>
            <div class="bax-section bax-select-patient-wrap">
                <div class="container" v-if="createPatient === false">
                    <div class="bax-section-title d-md-flex align-items-md-center">
                        <vue-heading size="1" v-if="!isTPN()">Select Patient</vue-heading>
                        <vue-heading size="1" v-if="isTPN()">Select TPN Patient</vue-heading>
                        <vue-button color="default" class="ml-auto" @click="skipPatientSelect">Skip this step</vue-button>
                    </div>
                    <vue-box class="bax-search-bar d-md-flex flex-wrap align-items-md-center">
                        <vue-heading :size="4">Select an Existing Patient</vue-heading>
                        <div class="bax-form-wrapper w-100">
                            <search-patient
                                :searchKeyword='searchKeyword'
                                @onSearch="searchPatient"
                            />
                        </div>
                    </vue-box>

                    <search-patient-list
                        id="searchList"
                        v-if="searchActive === true && searchedPatientsList.length > 0"
                        :patients="searchedPatientsList"
                        :keyword="searchedText"
                        @onPatientSelect="setSelectedPatient"
                        @onDrugSelect="setSelectedDrugs"
                    />

                    <template v-if="searchActive === true">
                        <div class="bax-cta-block d-flex" v-if="this.orderLines.length === 0">
                            <input
                                    type="button"
                                    value="Continue to drug selection"
                                    class="bax-btn bax-btn bax-btn-blue ml-auto"
                                    :disabled="patientId === ''"
                                    @click="addOrderPatient"
                            >
                        </div>
                        <div class="bax-cta-block d-flex" v-if="this.orderLines.length > 0">
                            <input
                                    type="button"
                                    value="Add to order and review"
                                    class="bax-btn bax-btn bax-btn-blue ml-auto"
                                    :disabled="patientId === ''"
                                    @click="addOrderPatient"
                            >
                        </div>
                    </template>


                    <vue-divider />

                    <vue-box class="d-md-flex align-items-md-center">
                        <vue-heading :size="4" v-if="!isTPN()">Create a New Patient</vue-heading>
                        <vue-heading :size="4" v-if="isTPN()">Create a New TPN Patient</vue-heading>
                        <div class="ml-auto">
                            <vue-button
                                color="primary"
                                @click="showCreatePatientForm"
                            >Create</vue-button>
                        </div>
                    </vue-box>
                    <div class="bax-cta-block">
                      <cancel-order-modal :add_more="orderInfo.add_more" cancelItem="Patient"></cancel-order-modal>
                    </div>
                </div>
                <div class="container" v-else>
                    <create-patient-form
                        @close="showSearchList"
                        @open="createPatient = true"
                        :apiDetails="this.apiDetails"
                    />
                </div>
            </div>
        </main>
    </app-layout>
</template>

<script>
import AppLayout from '@/components/layout/AppLayout.vue';
import SearchPatient from '@/components/patient/SearchPatient.vue';
import PatientService from '@/core/api/patient/patient.service';
import CreatePatientForm from '@/views/Order/SelectPatient/CreatePatientForm.vue';
import SearchPatientList from '@/views/Order/SelectPatient/SearchPatientList.vue';
import OrderService from '@/core/api/order/order.service';
import OrderDrugService from '@/core/api/order/orderDrug.service';
import { scrollPageToTop } from '@/core/helpers';
import CancelOrderModal from '@/components/order/CancelOrderModal.vue';
import BaxHeaderBanner from '@/components/layout/BaxHeaderBanner.vue';
import utilsMixin from '@/mixins/utilsMixin';
import tpnMixin from '@/mixins/tpnMixin';

export default {
    name: 'SelectPatient',
    mixins: [utilsMixin, tpnMixin],
    components: {
        AppLayout,
        SearchPatientList,
        CreatePatientForm,
        SearchPatient,
        CancelOrderModal,
        BaxHeaderBanner,
    },
    data() {
        return {
            createPatient: false,
            searchActive: false,
            searchKeyword: {
                firstName: '',
                lastName: '',
                patientId: '',
                error: '',
            },
            apiDetails: {
                api: '',
                region: '',
            },
            searchedPatientsList: [],
            searchedText: '',
            patientId: '',
            orderInfo: '',
            orderLines: [],
            reqDataQueue: [],
            addOrderPatientClicked: false,
        };
    },
    created() {
        scrollPageToTop();

        if (this.$route.params.orderId) {
            OrderService.orderInfo(this.$route.params.orderId).then((res) => {
                this.orderInfo = res;
                this.apiDetails.api = this.orderInfo.api;
                this.apiDetails.region = this.orderInfo.region;
            });
        }
    },
    methods: {
        skipPatientSelect() {
            this.$router.push({
                name: 'drugDetail',
                params: {
                    orderId: this.$route.params.orderId,
                },
            });
        },
        async processDrugAddQueue() {
            if (this.reqDataQueue.length > 0) {
                const reqData = this.reqDataQueue.pop();
                OrderDrugService.addDrugForPatient(reqData)
                    .then(() => {
                        if (this.reqDataQueue.length > 0) {
                            this.processDrugAddQueue();
                        } else {
                            const data = {};
                            data.orderRef = this.$route.params.orderId;

                            OrderService.orderCleanup(data).then(() => {
                                this.$router.push({
                                    name: 'reviewComplete',
                                    params: {
                                        orderId: this.$route.params.orderId,
                                    },
                                });
                            });
                        }
                    });
                }
        },
        addOrderPatient() {
            if (!this.addOrderPatientClicked) {
                this.addOrderPatientClicked = true;
                OrderService.addOrderPatient({
                    orderRef: this.$route.params.orderId,
                    patientId: this.patientId,
                })
                    .then(async () => {
                        if (this.orderLines.length === 0) {
                            this.$router.push({
                                name: 'drugDetail',
                                params: {
                                    orderId: this.$route.params.orderId,
                                    patient: this.patientId,
                                },
                            });
                        } else {
                            let i;
                            let reqData;
                            for (i = 0; i < this.orderLines.length; i += 1) {
                                const orderLine = this.orderLines[i];

                                if (orderLine.order_line_type.includes('PS')) {
                                    // PS order line
                                    reqData = {
                                        orderRef: this.$route.params.orderId,
                                        patientId: (typeof this.patientId === 'undefined') ? 0 : this.patientId,
                                        quantity: orderLine.quantity,
                                        drugPresentationId: orderLine.presentation_id ? orderLine.presentation_id : orderLine.masterPresentationId,
                                        drug1Dose: this.rounddec_2(orderLine.drug1Dose),
                                        drug2Dose: this.rounddec_2(orderLine.drug2Dose),
                                        containerTypeId: orderLine.containerTypeID,
                                        diluentVolume: orderLine.totalVolume,
                                        totalVolume: orderLine.totalVolume,
                                        diluentExactFinalVolume: orderLine.exactVolume === 'false' ? false : orderLine.exactVolume,
                                        adminRouteCode: orderLine.administrationRouteCode,
                                        ancillary1Id: orderLine.ancillary1ID,
                                        ancillary2Id: orderLine.ancillary2ID,
                                        infusionTime: orderLine.infusionTime,
                                        infusionTimeDuration: 'hours',
                                        containerPartCode: orderLine.containerPartCode,
                                        diluent_id: orderLine.diluentID,
                                        containerId: orderLine.containerID,
                                        container: orderLine.containerName ? orderLine.containerName : orderLine.container,
                                        overrideStability: orderLine.overrideStability,
                                        overrideDosage: orderLine.maxDosageExceededAccepted,
                                        type: 'PS',
                                    };

                                    // empty bag // reservior // syringe
                                    if (reqData.containerTypeId === '4' || reqData.containerTypeId === '8' || reqData.containerTypeId === '7') {
                                        if ((reqData.diluent_id !== '') && (reqData.diluent_id !== null)) {
                                            reqData.diluentExactFinalVolume = true;
                                            if (!reqData.diluentVolume) {
                                                reqData.diluentVolume = false;
                                            }
                                            if (!reqData.totalVolume) {
                                                reqData.totalVolume = false;
                                            }
                                        }
                                    }

                                    if (!orderLine.diluentID) {
                                        reqData.diluent_id = false;
                                        reqData.diluent_remove = true;
                                    }
                                } else {
                                    // FP order line
                                    reqData = {
                                        orderRef: this.$route.params.orderId,
                                        patientId: (typeof this.patientId === 'undefined') ? 0 : this.patientId,
                                        quantity: orderLine.quantity,
                                        drugPresentationId: orderLine.presentation_id ? orderLine.presentation_id : orderLine.masterPresentationId,
                                        fp_code: orderLine.finishedProductCode,
                                        type: 'FP',
                                        drug1Dose: this.rounddec_2(orderLine.drug1Dose),
                                    };
                                }

                                reqData.drugName = this.generateDrugName(orderLine);
                                reqData.isFavourite = false;
                                reqData.reordered = true;
                                this.reqDataQueue.push(reqData);
                            }

                            this.processDrugAddQueue();
                            // if (this.addingFpDrug) {
                            //     reqData = {
                            //         orderRef: this.$route.params.orderId,
                            //         patientId: (typeof this.patient.patientId === 'undefined') ? 0 : this.patient.patientId,
                            //         quantity: this.quantity,
                            //         drugPresentationId: this.drugPresentationId,
                            //         fp_code: this.drug1_product_code,
                            //         treatmentDate: this.treatmentDate,
                            //         type: 'FP',
                            //     };
                            // } else {
                            //     reqData = {
                            //         orderRef: this.$route.params.orderId,
                            //         patientId: (typeof this.patient.patientId === 'undefined') ? 0 : this.patient.patientId,
                            //         quantity: this.quantity,
                            //         drugPresentationId: this.drugPresentationId,
                            //         drug1Dose: this.drug1_dose,
                            //         drug2Dose: this.drug2_dose,
                            //         containerTypeId: this.containerTypeId,
                            //         diluentVolume: this.diluentVolume,
                            //         diluentExactFinalVolume: this.diluentExactFinalVolume,
                            //         treatmentDate: this.treatmentDate,
                            //         onHold: this.onHold,
                            //         adminRouteCode: this.adminRouteCode,
                            //         ancillary1Id: this.ancillary1Id,
                            //         ancillary2Id: this.ancillary2Id,
                            //         infusionTime: this.round_2(this.infusionTime),
                            //         containerPartCode: this.containerId,
                            //         diluent_id: this.diluent_id,
                            //         containerId: this.selectedConatierDescId,
                            //         overrideStability: this.overrideStability,
                            //         overrideDosage: this.maxDosageExceededAccepted,
                            //         type: 'PS',
                            //     };
                            // }
                            //
                            // reqData.drugName = this.generateDrugName();
                            // reqData.isFavourite = this.isFavourite;
                        }
                    });
            }
        },
        setSelectedPatient(id) {
            this.patientId = id;
        },
        setSelectedDrugs(orderLines) {
            this.orderLines = orderLines;
        },
        async searchPatient() {
            try {
                if (this.searchKeyword.firstName === ''
                    && this.searchKeyword.lastName === ''
                    && this.searchKeyword.patientId === ''
                ) {
                    this.searchKeyword.error = 'Please enter some search terms';
                    return;
                }
                const searchRequest = await PatientService.searchPatient({
                    firstName: this.searchKeyword.firstName,
                    lastName: this.searchKeyword.lastName,
                    patientId: this.searchKeyword.patientId,
                });

                this.searchedPatientsList = searchRequest.data;
                this.searchActive = true;

                let m = '';
                if (this.searchKeyword.firstName !== '') {
                    m += this.searchKeyword.firstName;
                }

                if (this.searchKeyword.lastName !== '') {
                    if (m !== '') {
                        m += ` ${this.searchKeyword.lastName}`;
                    } else {
                        m += this.searchKeyword.lastName;
                    }
                }

                if (this.searchKeyword.patientId !== '') {
                    if (m !== '') {
                        m += `, ${this.searchKeyword.patientId}`;
                    } else {
                        m += this.searchKeyword.patientId;
                    }
                }

                this.searchedText = m;

                // move the div to top
                setTimeout(() => {
                    const div = document.getElementById('searchList');
                    window.scrollTo({
                        behavior: 'smooth',
                        top: div.offsetTop - 40,
                    });
                }, 100);
            } catch (err) {
              if (err.response && err.response.status === 404) {
                this.searchedPatientsList = [];
              }
              if (err.response && err.response.status === 400) {
                if (err.response.data) {
                  switch (err.response.data.message) {
                    case 'too_many_records':
                        this.searchKeyword.error = 'Too many results returned - please refine your search';
                      break;
                    case 'none':
                        this.searchKeyword.error = 'No results returned for your keywords';
                      break;
                    default:
                      break;
                  }
                }
              }
            }
        },
        showCreatePatientForm() {
            this.createPatient = true;
            scrollPageToTop();
        },
        showSearchList() {
            this.createPatient = false;
            scrollPageToTop();
        },
    },
};
</script>
